import { Box, Typography } from "@mui/material";

const MyLegend = ({ series }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",   // 👈 center horizontally
        alignItems: "center",
        gap: 2,
        width: "100%",              // 👈 ensure full width container
      }}
    >
      {series.map((s, i) => (
        <Box key={i} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 12,
              height: 12,
              backgroundColor: s.color || getSeriesColor(i),
              borderRadius: "2px",
            }}
          />
          <Typography variant="body2">{s.name}</Typography>
        </Box>
      ))}
    </Box>
  );
};

// match Chartist series classes
const getSeriesColor = (i) => {
  const colors = ["#1976d2", "#2e7d32", "#d32f2f", "#ed6c02"];
  return colors[i % colors.length];
};

export default MyLegend;
